import React, { useState, useEffect } from "react";
import { Card, Table, Button, Loader, Icon, Alert } from "tabler-react";
import dateFormat from "dateformat";
import CopyBTN from "../../../../components/CopyBTN";

//hooks
import useExtractReportShopee from "../../../../hooks/api/GBT/extractions/useExtractTiktokOrders";
import useShopPending from "../../../../hooks/api/TiktokShop/useShopPending";

const TableResults = (props) => {
  const { orders, orderSummary, ordersCount, customLabel, fileName } = props;
  const { downloadOrders, downloadSummary } = useExtractReportShopee();
  const { pendingCount, addPendingOrders } = useShopPending();

  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  console.log(orderSummary);

  useEffect(() => {
    setLoading(true);
    setTimeout(function () {
      setLoading(false);
    }, 1000);
  }, [orders, customLabel, fileName]);

  return (
    <>
      {pendingCount == 0 ? (
        ""
      ) : (
        <Alert
          type="warning"
          // isDismissible
          className="alert-css"
        >
          <Icon prefix="fa" name="warning" />
          <span>
            {" "}
            You can't upload these orders to Tiktok Dashboard. You have{" "}
            {pendingCount} orders waiting for DR Approval.{" "}
            <a href="/TiktokShop/PendingDashboard" target="_blank">Pending Dashboard</a>{" "}
          </span>
        </Alert>
      )}

      <Card>
        <Card.Status color="cyan" side />
        <Card.Header>
          Generated Data
          <Card.Options>
            {ordersCount !== 0 ? (
              <>
                {orders.filter(
                  (order) => order.variant_name === "No Variant Name"
                ).length !== 0 ? (
                  <>
                    {filter === "" ? (
                      <Button
                        onClick={() => setFilter("No Variant Name")}
                        color="danger"
                      >
                        <Icon prefix="fa" name="eye" /> View Errors
                      </Button>
                    ) : (
                      <Button onClick={() => setFilter("")} color="cyan">
                        <Icon prefix="fa" name="eye" /> View All
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    <Button
                      onClick={() =>
                        downloadOrders(
                          orders,
                          `${fileName} - ${dateFormat(new Date(), "longDate")}`
                        )
                      }
                      color="cyan"
                    >
                      <Icon prefix="fa" name="download" /> Extract Generated
                      Orders
                    </Button>
                    <Button
                      onClick={() =>
                        downloadSummary(
                          orderSummary,
                          `${fileName} - ${dateFormat(new Date(), "longDate")}`
                        )
                      }
                      color="teal"
                    >
                      <Icon prefix="fa" name="download" /> Extract Order Summary
                    </Button>
                    {pendingCount == 0 ? (
                      <Button
                        onClick={() =>
                          addPendingOrders(orders, () =>
                            alert("New Orders Added Successfully!")
                          )
                        }
                        color="orange"
                      >
                        <Icon prefix="fa" name="upload" /> Upload Orders
                      </Button>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </>
            ) : (
              ""
            )}
          </Card.Options>
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div style={{ padding: "5px" }}>
              <Loader className="loader" />
            </div>
          ) : (
            <div className="table-result-container">
              <Table
                responsive
                highlightRowOnHover
                hasOutline
                verticalAlign="center"
                cards
                className="text-nowrap"
              >
                <Table.Header>
                  <Table.Row>
                    <Table.ColHeader>Order Date</Table.ColHeader>
                    <Table.ColHeader>Shipout Date</Table.ColHeader>
                    <Table.ColHeader>Order ID</Table.ColHeader>
                    <Table.ColHeader>Tracking Number</Table.ColHeader>
                    <Table.ColHeader>Shipping Option</Table.ColHeader>
                    <Table.ColHeader>Product SKU</Table.ColHeader>
                    <Table.ColHeader>Product Name</Table.ColHeader>
                    <Table.ColHeader>Quantity</Table.ColHeader>
                    <Table.ColHeader>Original Price</Table.ColHeader>
                    <Table.ColHeader>Deal Price</Table.ColHeader>
                    <Table.ColHeader>Product Subtotal</Table.ColHeader>
                    <Table.ColHeader>Buyer Paid Shipping Fee</Table.ColHeader>
                    <Table.ColHeader>Seller Voucher(PHP)</Table.ColHeader>
                    <Table.ColHeader>
                      Seller Absorbed Coin Cashback
                    </Table.ColHeader>
                    <Table.ColHeader>Tiktok Voucher(PHP)</Table.ColHeader>
                    <Table.ColHeader>Tiktok Coins Offset(PHP)</Table.ColHeader>
                    <Table.ColHeader>Gate Variant Name</Table.ColHeader>
                    <Table.ColHeader>Gross</Table.ColHeader>
                    <Table.ColHeader>Aquisition</Table.ColHeader>
                    <Table.ColHeader>Item Code</Table.ColHeader>
                    <Table.ColHeader>Variation Name</Table.ColHeader>
                  </Table.Row>
                </Table.Header>
                {orders
                  .filter((order) =>
                    filter ? order.variant_name === "No Variant Name" : order
                  )
                  .map((order, index) => (
                    <Table.Body>
                      <Table.Row>
                        <Table.Col>{order.order_date}</Table.Col>
                        <Table.Col>{order.shipout_date}</Table.Col>
                        <Table.Col>{order.order_id.replace("*", "")}</Table.Col>
                        <Table.Col>
                          {order.tracking_number.replace("*", "")}
                        </Table.Col>
                        <Table.Col>{order.shipping_option}</Table.Col>
                        <Table.Col>
                          {order.product_sku}{" "}
                          <CopyBTN value={order.product_sku} />
                        </Table.Col>
                        <Table.Col>
                          {order.product_name}{" "}
                          <CopyBTN value={order.product_name} />
                        </Table.Col>
                        <Table.Col>{order.quantity}</Table.Col>
                        <Table.Col>{order.gate_price}</Table.Col>
                        <Table.Col>{order.shopee_price}</Table.Col>
                        <Table.Col>{order.product_subtotal}</Table.Col>
                        <Table.Col>{order.buyer_paid_shipping_fee}</Table.Col>
                        <Table.Col>{order.seller_voucher}</Table.Col>
                        <Table.Col>{order.seller_coins}</Table.Col>
                        <Table.Col>{order.shopee_voucher}</Table.Col>
                        <Table.Col>{order.shopee_coins}</Table.Col>
                        <Table.Col>{order.variant_name}</Table.Col>
                        <Table.Col>{order.gross_price}</Table.Col>
                        <Table.Col>{order.aquisition}</Table.Col>
                        <Table.Col>{order.item_code}</Table.Col>
                        <Table.Col>{order.variation_name}</Table.Col>
                      </Table.Row>
                    </Table.Body>
                  ))}
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default TableResults;
